/** Lote crm8 (item 6): textos dos tipos de relatório da origem (Relatórios > "Tipo de relatório"), em `crm.relatorio.tipos`. */
export const tiposPt = {
  rotulo: 'Tipo de relatório',
  nomes: { painel: 'Painel', dashboard: 'Dashboard', pipeline: 'Pipeline', equipes: 'Equipes', feedback: 'Feedback', conversoes: 'Conversões', produtos: 'Produtos e Serviços', fontes: 'Fontes e Campanhas', metas: 'Metas', ligacoes: 'Ligações', comparativo: 'Comparativo de ligações' },
  todasLigacoes: 'Todas as ligações',
  minhasLigacoes: 'Minhas ligações',
  truncado: 'Mostrando as {{n}} negociações mais recentes do filtro.',
  ligacoesTruncado: 'Contando as {{n}} ligações mais recentes do filtro.',
  ops: 'Ops, não encontrei nenhum dado',
  opsTexto: 'Nossos motores de busca não encontraram nada para este filtro do relatório.',
  semDados: 'Nenhum dado disponível',
  painelControle: 'Painel de controle',
  criadasSerie: 'Negociações criadas',
  vendasSerie: 'Vendas',
  perdidasSerie: 'Negociações perdidas',
  valorVendido: 'Valor vendido',
  desempenho: 'Gráficos de desempenho',
  criadas: 'Criadas',
  vendas: 'Vendas',
  perdidas: 'Perdidas',
  funilCriacao: 'Funil por criação',
  valorUsuarios: 'Valor x Usuários',
  visaoGeral: 'Visão geral',
  funilVendas: 'Funil de vendas',
  semResponsavel: 'Sem responsável',
  semEquipe: 'Sem equipe',
  semFonte: 'Sem fonte',
  semCampanha: 'Sem campanha',
  pipelineVazio: 'Não há nenhuma negociação no Pipeline com os filtros aplicados.',
  etapaResumo: '{{etapa}} ({{n}}) · {{valor}}',
  negociacoes: 'Negociações',
  colunas: { negociacao: 'Negociação', etapa: 'Etapa', responsavel: 'Responsável', fonte: 'Fonte', valor: 'Valor', ultimoContato: 'Último contato' },
  abas: { equipes: 'Equipes', pipeline: 'Pipeline', produtos: 'Produtos e serviços', fontes: 'Fontes', campanhas: 'Campanhas', individuais: 'Individuais', equipe: 'Equipe', empresa: 'Empresa', individual: 'Individual' },
  vendasValores: 'Vendas em valores',
  vendasUnidades: 'Vendas em unidades',
  pipelineEquipe: 'Pipeline por equipe',
  periodoContato: 'Período do último contato',
  etapa: 'Etapa',
  selecioneEtapa: 'Todas as etapas',
  faixas: { ate7: 'Até 7 dias', ate30: '8 a 30 dias', mais30: 'Mais de 30 dias', sem: 'Sem contato' },
  porUsuario: 'Negociações por usuário',
  filtradas: 'Negociações filtradas ({{n}})',
  conversaoVolume: 'Conversão por volume',
  conversaoFinal: 'Conversão final',
  perdidosEtapa: 'Quantidade de perdidos por etapa',
  vendasEtapa: 'Quantidade de vendas por etapa',
  produtosPipeline: 'Produtos no pipeline',
  produtosValor: 'Total monetário de negociações vendidas',
  produtosQuantidade: 'Quantidade de negociações vendidas',
  produtosNota: 'Exibindo apenas produtos e serviços vendidos do filtro aplicado',
  fontesOrdenadas: 'Fontes ordenadas por',
  campanhasOrdenadas: 'Campanhas ordenadas por',
  ordenarPor: 'Ordenar por',
  ordens: { criadas: 'Criadas', vendidas: 'Vendidas', perdidas: 'Perdidas' },
  campanhas: 'Campanhas',
  fontes: 'Fontes',
  responsaveis: 'Responsáveis',
  statusFinal: 'Status final das negociações',
  andamento: 'Em andamento',
  vendidas: 'Vendidas',
  ligacoesPeriodo: 'Quantidade de ligações no período',
  realizadas: 'Realizadas',
  ligacoesNota: 'Ligações concluídas nas negociações do filtro. O MalgoOS não registra se a ligação foi atendida nem o tempo dela.',
  ligacoesRealizadas: 'Quantidade de ligações no período: realizadas',
  totalGeral: 'Total geral',
  crieMeta: 'Crie uma meta',
  crieMetaTexto: 'Configure objetivos de vendas e acompanhe a performance do seu time',
  criarMeta: 'Criar uma meta',
  metasMes: 'Metas do mês',
};
export const tiposEn: typeof tiposPt = {
  rotulo: 'Report type',
  nomes: { painel: 'Overview', dashboard: 'Dashboard', pipeline: 'Pipeline', equipes: 'Teams', feedback: 'Feedback', conversoes: 'Conversions', produtos: 'Products and Services', fontes: 'Sources and Campaigns', metas: 'Goals', ligacoes: 'Calls', comparativo: 'Call comparison' },
  todasLigacoes: 'All calls',
  minhasLigacoes: 'My calls',
  truncado: 'Showing the {{n}} most recent deals of the filter.',
  ligacoesTruncado: 'Counting the {{n}} most recent calls of the filter.',
  ops: "Oops, I couldn't find any data",
  opsTexto: 'Our search engines found nothing for this report filter.',
  semDados: 'No data available',
  painelControle: 'Control panel',
  criadasSerie: 'Deals created',
  vendasSerie: 'Sales',
  perdidasSerie: 'Deals lost',
  valorVendido: 'Value sold',
  desempenho: 'Performance charts',
  criadas: 'Created',
  vendas: 'Sales',
  perdidas: 'Lost',
  funilCriacao: 'Funnel by creation',
  valorUsuarios: 'Value x Users',
  visaoGeral: 'Overview',
  funilVendas: 'Sales funnel',
  semResponsavel: 'No owner',
  semEquipe: 'No team',
  semFonte: 'No source',
  semCampanha: 'No campaign',
  pipelineVazio: 'There are no deals in the Pipeline with the applied filters.',
  etapaResumo: '{{etapa}} ({{n}}) · {{valor}}',
  negociacoes: 'Deals',
  colunas: { negociacao: 'Deal', etapa: 'Stage', responsavel: 'Owner', fonte: 'Source', valor: 'Value', ultimoContato: 'Last contact' },
  abas: { equipes: 'Teams', pipeline: 'Pipeline', produtos: 'Products and services', fontes: 'Sources', campanhas: 'Campaigns', individuais: 'Individual', equipe: 'Team', empresa: 'Company', individual: 'Individual' },
  vendasValores: 'Sales by value',
  vendasUnidades: 'Sales by units',
  pipelineEquipe: 'Pipeline by team',
  periodoContato: 'Time since last contact',
  etapa: 'Stage',
  selecioneEtapa: 'All stages',
  faixas: { ate7: 'Up to 7 days', ate30: '8 to 30 days', mais30: 'Over 30 days', sem: 'No contact' },
  porUsuario: 'Deals by user',
  filtradas: 'Filtered deals ({{n}})',
  conversaoVolume: 'Conversion by volume',
  conversaoFinal: 'Final conversion',
  perdidosEtapa: 'Lost deals by stage',
  vendasEtapa: 'Sales by stage',
  produtosPipeline: 'Products in the pipeline',
  produtosValor: 'Total value of deals sold',
  produtosQuantidade: 'Number of deals sold',
  produtosNota: 'Showing only products and services sold in the applied filter',
  fontesOrdenadas: 'Sources sorted by',
  campanhasOrdenadas: 'Campaigns sorted by',
  ordenarPor: 'Sort by',
  ordens: { criadas: 'Created', vendidas: 'Sold', perdidas: 'Lost' },
  campanhas: 'Campaigns',
  fontes: 'Sources',
  responsaveis: 'Owners',
  statusFinal: 'Final status of deals',
  andamento: 'In progress',
  vendidas: 'Sold',
  ligacoesPeriodo: 'Number of calls in the period',
  realizadas: 'Made',
  ligacoesNota: 'Calls completed on the deals of the filter. MalgoOS does not record whether the call was answered or how long it took.',
  ligacoesRealizadas: 'Number of calls in the period: made',
  totalGeral: 'Grand total',
  crieMeta: 'Create a goal',
  crieMetaTexto: 'Set sales goals and track your team’s performance',
  criarMeta: 'Create a goal',
  metasMes: 'Goals of the month',
};
export const tiposEs: typeof tiposPt = {
  rotulo: 'Tipo de informe',
  nomes: { painel: 'Panel', dashboard: 'Dashboard', pipeline: 'Pipeline', equipes: 'Equipos', feedback: 'Feedback', conversoes: 'Conversiones', produtos: 'Productos y Servicios', fontes: 'Fuentes y Campañas', metas: 'Metas', ligacoes: 'Llamadas', comparativo: 'Comparativo de llamadas' },
  todasLigacoes: 'Todas las llamadas',
  minhasLigacoes: 'Mis llamadas',
  truncado: 'Mostrando las {{n}} negociaciones más recientes del filtro.',
  ligacoesTruncado: 'Contando las {{n}} llamadas más recientes del filtro.',
  ops: 'Ups, no encontré ningún dato',
  opsTexto: 'Nuestros motores de búsqueda no encontraron nada para este filtro del informe.',
  semDados: 'No hay datos disponibles',
  painelControle: 'Panel de control',
  criadasSerie: 'Negociaciones creadas',
  vendasSerie: 'Ventas',
  perdidasSerie: 'Negociaciones perdidas',
  valorVendido: 'Valor vendido',
  desempenho: 'Gráficos de desempeño',
  criadas: 'Creadas',
  vendas: 'Ventas',
  perdidas: 'Perdidas',
  funilCriacao: 'Embudo por creación',
  valorUsuarios: 'Valor x Usuarios',
  visaoGeral: 'Visión general',
  funilVendas: 'Embudo de ventas',
  semResponsavel: 'Sin responsable',
  semEquipe: 'Sin equipo',
  semFonte: 'Sin fuente',
  semCampanha: 'Sin campaña',
  pipelineVazio: 'No hay ninguna negociación en el Pipeline con los filtros aplicados.',
  etapaResumo: '{{etapa}} ({{n}}) · {{valor}}',
  negociacoes: 'Negociaciones',
  colunas: { negociacao: 'Negociación', etapa: 'Etapa', responsavel: 'Responsable', fonte: 'Fuente', valor: 'Valor', ultimoContato: 'Último contacto' },
  abas: { equipes: 'Equipos', pipeline: 'Pipeline', produtos: 'Productos y servicios', fontes: 'Fuentes', campanhas: 'Campañas', individuais: 'Individuales', equipe: 'Equipo', empresa: 'Empresa', individual: 'Individual' },
  vendasValores: 'Ventas en valores',
  vendasUnidades: 'Ventas en unidades',
  pipelineEquipe: 'Pipeline por equipo',
  periodoContato: 'Período del último contacto',
  etapa: 'Etapa',
  selecioneEtapa: 'Todas las etapas',
  faixas: { ate7: 'Hasta 7 días', ate30: '8 a 30 días', mais30: 'Más de 30 días', sem: 'Sin contacto' },
  porUsuario: 'Negociaciones por usuario',
  filtradas: 'Negociaciones filtradas ({{n}})',
  conversaoVolume: 'Conversión por volumen',
  conversaoFinal: 'Conversión final',
  perdidosEtapa: 'Cantidad de perdidas por etapa',
  vendasEtapa: 'Cantidad de ventas por etapa',
  produtosPipeline: 'Productos en el pipeline',
  produtosValor: 'Total monetario de negociaciones vendidas',
  produtosQuantidade: 'Cantidad de negociaciones vendidas',
  produtosNota: 'Mostrando solo los productos y servicios vendidos del filtro aplicado',
  fontesOrdenadas: 'Fuentes ordenadas por',
  campanhasOrdenadas: 'Campañas ordenadas por',
  ordenarPor: 'Ordenar por',
  ordens: { criadas: 'Creadas', vendidas: 'Vendidas', perdidas: 'Perdidas' },
  campanhas: 'Campañas',
  fontes: 'Fuentes',
  responsaveis: 'Responsables',
  statusFinal: 'Estado final de las negociaciones',
  andamento: 'En curso',
  vendidas: 'Vendidas',
  ligacoesPeriodo: 'Cantidad de llamadas en el período',
  realizadas: 'Realizadas',
  ligacoesNota: 'Llamadas concluidas en las negociaciones del filtro. MalgoOS no registra si la llamada fue atendida ni cuánto duró.',
  ligacoesRealizadas: 'Cantidad de llamadas en el período: realizadas',
  totalGeral: 'Total general',
  crieMeta: 'Crea una meta',
  crieMetaTexto: 'Configura objetivos de ventas y sigue el desempeño de tu equipo',
  criarMeta: 'Crear una meta',
  metasMes: 'Metas del mes',
};
